export function register() {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      navigator.serviceWorker.register('/sw.js').then(
        (registration) => {
          console.log('Сервис воркер зарегестрирован: ', registration.scope);
        },
        (err) => {
          console.log('Сервис воркер не зарегестрирован: ', err);
        }
      );
    });
  }
}